// mixpanel.ts
import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = '0b85f49435ae22ba298234b62c20a25e';

export function initMixpanel(search: string = window.location.search) {
  mixpanel.init(MIXPANEL_TOKEN, {
    track_pageview: 'full-url'
   });

  const params = new URLSearchParams(search);
  const organization = params.get("organization");
  const nickname = params.get("nickname");

  if (organization) mixpanel.register({ organization });
  if (nickname) mixpanel.register({ nickname });

  mixpanel.register({ device: 'Tablet' });

  return mixpanel;
}